export function resolveIsOwner(
  currentUserId: string | null | undefined,
  owners: ReadonlyArray<{ id: string }> | undefined,
): boolean {
  if (typeof currentUserId !== 'string' || currentUserId.trim().length === 0) {
    return false;
  }
  if (owners === undefined || owners.length === 0) {
    return false;
  }
  return owners.some((owner) => owner.id === currentUserId);
}

export function resolveCanDeleteSixFile(
  currentUserId: string | null | undefined,
  owners: ReadonlyArray<{ id: string }> | undefined,
  uploadedByUserId: string | undefined,
): boolean {
  if (resolveIsOwner(currentUserId, owners)) {
    return true;
  }

  if (typeof currentUserId !== 'string' || currentUserId.trim().length === 0) {
    return false;
  }

  if (typeof uploadedByUserId !== 'string' || uploadedByUserId.trim().length === 0) {
    return false;
  }

  return uploadedByUserId === currentUserId;
}

function normalizePermissionPath(path: string | undefined): string | undefined {
  if (typeof path !== 'string') {
    return undefined;
  }

  const trimmedPath = path.replace(/\/+$/, '');

  if (trimmedPath.length === 0 || trimmedPath === '/') {
    return undefined;
  }

  return trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`;
}

export function resolveCanDeleteSixFolder(
  currentUserId: string | null | undefined,
  owners: ReadonlyArray<{ id: string }> | undefined,
  entries: ReadonlyArray<{
    kind: 'folder' | 'file';
    path?: string;
    uploadedByUserId?: string;
    createdByUserId?: string;
  }>,
  folderPath: string | undefined,
): boolean {
  if (resolveIsOwner(currentUserId, owners)) {
    return true;
  }

  if (typeof currentUserId !== 'string' || currentUserId.trim().length === 0) {
    return false;
  }

  const normalizedFolderPath = normalizePermissionPath(folderPath);

  if (normalizedFolderPath === undefined) {
    return false;
  }

  const subtreeEntries = entries.filter((entry) => {
    const normalizedEntryPath = normalizePermissionPath(entry.path);

    if (normalizedEntryPath === undefined) {
      return false;
    }

    return normalizedEntryPath === normalizedFolderPath || normalizedEntryPath.startsWith(`${normalizedFolderPath}/`);
  });

  return subtreeEntries.every((entry) => {
    if (entry.kind === 'folder') {
      return entry.createdByUserId === currentUserId;
    }

    return entry.uploadedByUserId === currentUserId;
  });
}
